import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.ORANGE,
    codeProp: 'rmNo',
    detailUrl: '/RulemRmDetail',
    detailIdProp: 'rmId',
    listUrl: '/RulemRmList',
    mapProp: 'rmMap',
    name: '知识模块',
    textProp: 'rmName',
    type: 'RULEMRM',
}
